module.exports = __webpack_public_path__ + "static/img/首页banner.edd083b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/首页banner.jpg
// module id = L5sy
// module chunks = 15